import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { Button, Card, Col, Row, Table } from 'react-bootstrap';
import { MdDelete, MdEdit, MdShare } from 'react-icons/md';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { default as swal } from 'sweetalert2';
import Pagination from '../../Pagination';
import './HrDashboard.css';
import { FaBars } from 'react-icons/fa';

const MyJobs = () => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const userEmail = location.state?.userEmail;
  const userName = location.state?.userName;
  const [jobs, setJobs] = useState([]);
  const [selectedJobSummary, setSelectedJobSummary] = useState('');
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null); // Track the currently sorted column
  const [sortOrder, setSortOrder] = useState(' '); // Track the sort order (asc or desc)
  const currentPage = location.state?.currentPage || 0;
  const [page, setPage] = useState(currentPage);
  const currentPageSize = location.state?.currentPageSize || 6; // Default page size
  const [pageSize, setPageSize] = useState(currentPageSize); // Default to 5 items per page

  useEffect(() => {
    if (location.state?.currentPage === undefined && location.state?.currentPageSize === undefined) {
      setPage(0);
      setPageSize(6); // Set default page size to 5
    }
  }, [location.state?.currentPage, location.state?.currentPageSize]);
  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(0);
  };

  const handleSort = (column) => {
    let order = 'asc';
    if (sortedColumn === column) {
      order = sortOrder === 'asc' ? 'desc' : 'asc';
    }
    setSortedColumn(column);
    setSortOrder(order);
  };

  const handleDelete = (jobId) => {
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!" + " All applications will be deleted",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        // Delete job only if user confirms
        deleteJob(jobId);
      }
    });
  };

  // Function to perform the delete action
  const deleteJob = async (jobId) => {
    try {
      await axios.delete(`${BASE_API_URL}/deleteJob?jobId=${jobId}`);
      setJobs(prevJobs => prevJobs.filter(job => job.jobId !== jobId));
      swal.fire(
        'Deleted!',
        'The job has been deleted.',
        'success'
      );
    } catch (error) {
      swal.fire(
        'Error!',
        'An error occurred while deleting the job.',
        'error'
      );
    }
  };


  const fetchJobs = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        userEmail: userEmail,
        page: page,
        size: pageSize,
        sortBy: sortedColumn,
        sortOrder: sortOrder,
      };
      const response = await axios.get(`${BASE_API_URL}/jobsPostedByHrEmail`, { params });
      setJobs(response.data.content);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
    }
  }, [userEmail, page, pageSize, sortedColumn, sortOrder]);

  const fetchJobBySearch = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_API_URL}/searchJobsByHR`, {
        params: {
          search, userEmail, page, pageSize, sortBy: sortedColumn,
          sortOrder: sortOrder,
        }
      });
      setJobs(response.data.content);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
      alert('Error searching for jobs. Please try again later.');
    }
  }, [search, userEmail, page, pageSize, sortedColumn, sortOrder]);

  useEffect(() => {
    if (search) {
      fetchJobBySearch();
    } else {
      fetchJobs();
    }
  }, [fetchJobBySearch, fetchJobs, search]);

  const handleViewSummary = (summary) => {
    setSelectedJobSummary(summary);
  };

  const handleCloseModal = () => {
    setSelectedJobSummary(null);
  };
  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0); // Reset page when page size change
  };
  const isLastPage = page === totalPages - 1;
  const isPageSizeDisabled = isLastPage;


  const handlePageClick = (data) => {
    const selectedPage = data.selected;
    setPage(selectedPage);

  };
  const handleShare = (job) => {
    const slug = `${job.jobId}-${job.jobTitle
      .replace(/\s+/g, "-")
      .toLowerCase()}-${job.companyName.replace(/\s+/g, "-").toLowerCase()}`;
    const shareUrl = `${window.location.origin}/browse-jobs/job-details/${slug}`;
    //const shareUrl = `${window.location.origin}/job-details/${jobId}`; // Or however your public job link is structured

    if (navigator.share) {
      navigator.share({
        title: 'Job Opportunity',
        text: 'Check out this job!',
        url: shareUrl,
      })
        .then(() => console.log('Job shared successfully'))
        .catch((error) => console.error('Error sharing', error));
    } else {
      navigator.clipboard.writeText(shareUrl)
        .then(() => {
          swal.fire({
            title: 'Link Copied!',
            text: 'Job link copied to clipboard. You can share it now.',
            icon: 'success',
            timer: 2000,
            showConfirmButton: false
          });
        })
        .catch(() => {
          swal.fire({
            title: 'Error',
            text: 'Could not copy link. Please try again.',
            icon: 'error'
          });
        });
    }
  };

  return (
    <div >
      <Row>
        <Col md={4}>
        </Col>
        <Col md={4} className="d-flex align-items-left">
          {/* Search Bar */}
          <div className="search-bar" style={{ flex: 1 }}>
            <input
              style={{
                borderColor: '#6c5b7b',
                borderRadius: '6px',
                height: '40px', // Match the height of the select
                width: '100%', // Full width
                padding: '0 10px', // Add horizontal padding for text
              }} type="text"
              name="search"
              placeholder="Search"
              value={search}
              onChange={handleSearchChange}
            />
          </div>
          <Button style={{ marginRight: '25px', maxWidth: '100px' }} className='job-button'>
            <Link
              to={{ pathname: '/hr-dashboard/my-jobs/addJob', state: { userName, userEmail } }}
              onClick={(e) => {
                e.preventDefault();
                navigate('/hr-dashboard/my-jobs/addJob', { state: { userName, userEmail } });
              }}
              style={{ textDecoration: 'none', color: 'inherit' }} // removes default link styling
            >
              Add Job
            </Link>
          </Button>
        </Col>
      </Row>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div className="spinner-bubble spinner-bubble-primary m-5" />
          <span>Loading...</span>
        </div>
      ) : jobs.length > 0 ? (
        <>
          <div>
            <Card body>
              {/* <Card.Title>Light hoverable Table</Card.Title>

                <p>
                  Add <code>.table-hover</code> to enable a hover state on table rows within a{" "}
                  <code>&lt;tbody&gt;</code>.
                </p> */}
              <div className="table-details-list table-wrapper">
                <Table hover responsive >
                  <thead>
                    <tr>
                      <th scope="col" onClick={() => handleSort('jobTitle')} style={{ cursor: 'pointer' }}>
                        Job Title{' '}
                        <span>
                          <span style={{ color: sortedColumn === 'jobTitle' && sortOrder === 'asc' ? 'black' : 'gray', }}>↑</span>{' '}
                          <span style={{ color: sortedColumn === 'jobTitle' && sortOrder === 'desc' ? 'black' : 'gray', }}>↓</span>
                        </span>
                      </th>

                      <th
                        scope="col"
                        onClick={() => handleSort('jobType')}
                        style={{ cursor: 'pointer' }}
                      >
                        Job Type{' '}
                        <span>
                          <span
                            style={{
                              color: sortedColumn === 'jobType' && sortOrder === 'asc' ? 'black' : 'gray',
                            }}
                          >
                            ↑
                          </span>{' '}
                          <span
                            style={{
                              color: sortedColumn === 'jobType' && sortOrder === 'desc' ? 'black' : 'gray',
                            }}
                          >
                            ↓
                          </span>
                        </span>
                      </th>
                      <th
                        scope="col"
                        onClick={() => handleSort('postingDate')}
                        style={{ cursor: 'pointer' }}
                      >
                        Posting Date{' '}
                        <span>
                          <span
                            style={{
                              color: sortedColumn === 'postingDate' && sortOrder === 'asc' ? 'black' : 'gray',
                            }}
                          >
                            ↑
                          </span>{' '}
                          <span
                            style={{
                              color: sortedColumn === 'postingDate' && sortOrder === 'desc' ? 'black' : 'gray',
                            }}
                          >
                            ↓
                          </span>
                        </span>
                      </th>
                      <th
                        scope="col"
                        onClick={() => handleSort('skills')}
                        style={{ cursor: 'pointer' }}
                      >
                        Skills{' '}
                        <span>
                          <span
                            style={{
                              color: sortedColumn === 'skills' && sortOrder === 'asc' ? 'black' : 'gray',
                            }}
                          >
                            ↑
                          </span>{' '}
                          <span
                            style={{
                              color: sortedColumn === 'skills' && sortOrder === 'desc' ? 'black' : 'gray',
                            }}
                          >
                            ↓
                          </span>
                        </span>
                      </th>
                      <th
                        scope="col"
                        onClick={() => handleSort('numberOfPosition')}
                        style={{ cursor: 'pointer' }}
                      >
                        No of Position{' '}
                        <span>
                          <span
                            style={{
                              color: sortedColumn === 'numberOfPosition' && sortOrder === 'asc' ? 'black' : 'gray',
                            }}
                          >
                            ↑
                          </span>{' '}
                          <span
                            style={{
                              color: sortedColumn === 'numberOfPosition' && sortOrder === 'desc' ? 'black' : 'gray',
                            }}
                          >
                            ↓
                          </span>
                        </span>
                      </th>

                      <th
                        scope="col"
                        onClick={() => handleSort('salary')}
                        style={{ cursor: 'pointer' }}
                      >
                        Salary{' '}
                        <span>
                          <span
                            style={{
                              color: sortedColumn === 'salary' && sortOrder === 'asc' ? 'black' : 'gray',
                            }}
                          >
                            ↑
                          </span>{' '}
                          <span
                            style={{
                              color: sortedColumn === 'salary' && sortOrder === 'desc' ? 'black' : 'gray',
                            }}
                          >
                            ↓
                          </span>
                        </span>
                      </th>
                      <th scope="col">Experience</th>

                      <th
                        scope="col"
                        onClick={() => handleSort('applicationDeadline')}
                        style={{ cursor: 'pointer' }}
                      >
                        Application Deadline{' '}
                        <span>
                          <span
                            style={{
                              color: sortedColumn === 'applicationDeadline' && sortOrder === 'asc' ? 'black' : 'gray',
                            }}
                          >
                            ↑
                          </span>{' '}
                          <span
                            style={{
                              color: sortedColumn === 'applicationDeadline' && sortOrder === 'desc' ? 'black' : 'gray',
                            }}
                          >
                            ↓
                          </span>
                        </span>
                      </th>
                      <th scope="col">Job Description</th>
                      <th scope="col">Action</th>
                      {/* <th>Share</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {jobs.map((job) => (
                      <tr key={job.jobId}>
                        <td>{job.jobTitle}</td>
                        <td>{job.jobType}</td>
                        <td>{job.postingDate}</td>
                        <td>{job.skills}</td>
                        <td>{job.numberOfPosition}</td>
                        <td>{job.salary}</td>
                        <td>{job.minExp} - {job.maxExp} years</td>

                        <td>
                          {job.jobCategory === 'evergreen' && !job.applicationDeadline ? (
                            <span style={{ color: 'green', fontWeight: 'bold' }} title="This position is always open for hiring, feel free to apply anytime!">
                              Evergreen Job - No Due Date
                            </span>
                          ) : (
                            job.applicationDeadline || 'Not Specified'
                          )}
                        </td>
                        <td>
                          <Button variant="secondary" className="description btn-rounded" onClick={() => handleViewSummary(job.jobsummary)}>
                            Summary
                          </Button>
                        </td>
                        <td>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                             {/* New edit button */}
                            <span
                              className="cursor-pointer text-success me-2 update"
                              onClick={() =>
                                navigate('/hr-dashboard/my-jobs/update-job', {
                                  state: { userName, userEmail, jobId: job.jobId, currentPage: page, currentPageSize: pageSize },
                                })
                              }
                            >
                              <MdEdit size={18} className="text-success" />
                            </span>
                             {/* New view list button */}
                            <span className="delete cursor-pointer text-secondary me-2" onClick={() =>
                                navigate('/hr-dashboard/hr-applications/view-applications', {
                                    state: {
                                      userName,
                                      userEmail,
                                      jobId: job.jobId,
                                      jobTitle:job.jobTitle,
                                      currentJobApplicationPage: page,
                                      currentJobApplicationPageSize: pageSize,
                                      companyName: job.companyName,
                                    },
                                  })}>
                              <FaBars className="text-info" size={18} />
                            </span>
                            {/* New Share button */}
                            <span
                              className="cursor-pointer text-success me-2 update" onClick={() => handleShare(job)}>
                              <MdShare size={18} className="text-success" />
                            </span>
                             {/* New delete button */}
                             <span className="delete cursor-pointer text-danger me-2" onClick={() => handleDelete(job.jobId)}>
                              <MdDelete className="text-danger" size={18} />
                            </span>
                          </div>
                        </td>
                        {/* <td>
                          <Button
                            variant='success' onClick={() => handleShare(job)}>
                            {/* <MdShare size={18}/> Share  Share
                          </Button></td> */}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              {/* Pagination */}
              <Pagination
                page={page}
                pageSize={pageSize}
                totalPages={totalPages}
                handlePageSizeChange={handlePageSizeChange}
                isPageSizeDisabled={isPageSizeDisabled}
                handlePageClick={handlePageClick}
              />
            </Card>

          </div>

        </>
      ) : (
        <section className="no-jobs-message">
          <div style={{ color: 'red', textAlign: 'center' }}>
            {search
              ? `There is no job with this "${search}"`
              : 'You have not posted any jobs yet. Post Now'}
          </div>
        </section>
      )}

      {selectedJobSummary && (
        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
          <div className="modal-dialog" role="document" >   {/*style={{ minWidth: '300px', maxWidth: '80%' }} */}
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Job Summary</h5>
              </div>
              <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                <pre className="job-details-text">{selectedJobSummary}</pre>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      handleCloseModal();
                    }
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


    </div>
  );
};
export default MyJobs;
